import React, { useEffect, useState } from "react";
import { initGA, logPageView } from "../../Analytics";
import { Card, Tabs } from "antd";
import modules from "../../config/modules";

import "./Home.css";

const { Meta } = Card;
const { TabPane } = Tabs;

const Home = props => {
  const [activeTab, setActiveTab] = useState("nwp");
  
  // Google analytics
  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      initGA();
      logPageView();
    }
  }, []);
  return (
    <div className="homepage">
      <div className="homepage-part-1">
        <>
          <h2>
            Welcome to the WIGOS Data Quality Monitoring System (WDQMS) webtool
          </h2>
          <p>
            The WDQMS webtool is a resource developed by WMO to monitor the
            performance of all WIGOS observing components.
          </p>
          <p>
            For more information about the webtool, click{" "}
            <a href="/about" target="_blank">
              here
            </a>
            .
          </p>
          <h3>
            Four modules are currently available for the WIGOS monitoring:
          </h3>
        </>
      </div>
      <div className="homepage-part-2">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="wdqms-tabs"
          animated={false}
        >
          {Object.entries(modules).map(([moduleKey, moduleData]) => (
            <TabPane tab={moduleData.tabLabel} key={moduleKey}>
              <div className="tab-content">
                <div className={"data-module " + moduleKey}>
                  <div className="data-module-body">
                    {Object.entries(moduleData.networks).map(([networkKey, networkData]) => {
                      // If the property 'hasImage' is true, display the
                      // image. Otherwise, display a 'div' that contains
                      // the text defined in the property 'textNoImage'
                      const cover = networkData.hasImage ? (
                        <img alt={networkKey} src={networkData.imagePath} />
                      ) : (
                        <div>{networkData.textNoImage}</div>
                      );

                      return (
                        <a
                          key={networkKey}
                          href={`/${moduleKey}/${networkKey}`}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <Card hoverable cover={cover}>
                            <Meta
                              title={networkData.title}
                              description={networkData.description}
                            />
                          </Card>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default Home;
